import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

const SUPPORTED_THUMNAIL_DOMAINS = ['youtube', 'youtu.be', 'vimeo'];

const VideoPlayer = ({ url }) => {
  const [hasWindow, setHasWindow] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasWindow(true);
    }
  }, []);
  let showDefaultPlaceholder = true;

  SUPPORTED_THUMNAIL_DOMAINS.forEach((domain) => {
    if (url.includes(domain)) showDefaultPlaceholder = false;
  });

  if (!hasWindow) return null;

  return (
    <div className="player-wrapper">
      <ReactPlayer
        src={url}
        className="react-player__preview"
        width="100%"
        height="100%"
        controls
        light={showDefaultPlaceholder ? '/static/video-placeholder.webp' : true}
        playing
        playIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66.004"
            height="66.004"
            viewBox="0 0 66.004 66.004"
          >
            <g
              id="Group_1340"
              data-name="Group 1340"
              transform="translate(-126.998 -1099)"
            >
              <path
                id="Subtraction_8"
                data-name="Subtraction 8"
                d="M15911,21254a32.9,32.9,0,1,1,12.846-2.594A32.78,32.78,0,0,1,15911,21254Zm0-61a27.9,27.9,0,1,0,10.9,2.2A27.872,27.872,0,0,0,15911,21193Z"
                transform="translate(-15751 -20089)"
                opacity="0.7"
              />
              <path
                id="Subtraction_7"
                data-name="Subtraction 7"
                d="M15906,21244a27.917,27.917,0,1,1,10.9-2.2A27.81,27.81,0,0,1,15906,21244Zm-5.362-39a1.515,1.515,0,0,0-1.639,1.467v19.027a1.487,1.487,0,0,0,1.568,1.5,2.207,2.207,0,0,0,1.146-.336l15.451-9.186a1.711,1.711,0,0,0,0-2.943l-15.451-9.234A2.1,2.1,0,0,0,15900.636,21205Z"
                transform="translate(-15746 -20084)"
                fill="#fff"
                opacity="0.85"
              />
              <path
                id="Path_5563"
                data-name="Path 5563"
                d="M46.531-22.922l-15.45,9.183c-1.263.77-2.711.159-2.711-1.168V-33.936c0-1.3,1.553-1.858,2.711-1.168l15.45,9.236A1.712,1.712,0,0,1,46.531-22.922Z"
                transform="translate(124.63 1156.402)"
                opacity="0.7"
              />
            </g>
          </svg>
        }
      />
    </div>
  );
};

export default VideoPlayer;
